export default __webpack_public_path__ + "static/media/faq-header.41e26eec.png";